import { PortalIcon, type PortalIconProps } from './portal-icon';

/** Plus — add item / quantity. */
export function PlusIcon(props: PortalIconProps) {
  return (
    <PortalIcon {...props}>
      <path d="M12 5v14M5 12h14" />
    </PortalIcon>
  );
}
